import React, {useState} from "react"
import ReactApexChart from "react-apexcharts"

const FilesCountChart = (props) => {
  return (
    <React.Fragment>
      <ReactApexChart
        options={{
          chart: {
            stacked: true,
            toolbar: {
              show: false,
            },
            zoom: {
              enabled: true,
            },
          },
          plotOptions: {
            bar: {
              horizontal: false,
              columnWidth: "15%",
              endingShape: "rounded",
            },
          },
          dataLabels: {
            enabled: false,
          },
          xaxis: {
            categories: props.categories || [],
          },
          colors: ["#0984e3", "#fdcb6e", "#00b894", "#ff7675", "#a29bfe"],
          legend: {
            position: "bottom",
          },
          fill: {
            opacity: 1,
          }
        }}
        series={props.chartSeries || []}
        type="bar"
        height="360"
        className="apex-charts"
      />
    </React.Fragment>
  )
}

export default FilesCountChart
